// import components
import { Box, keyframes, styled } from '@mui/material';

export const bounceOutAtFixedFooter = keyframes`
  0% { bottom: -16px; }       /* Start position */
  30% { bottom: 0; }          /* Move up slightly */
  100% { bottom: -100px; }    /* Drop out completely */
`;

export const StyledTenantFooterBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isHidden'
})<{
  isHidden: boolean;
}>(({ isHidden, theme }) => ({
  position: 'fixed',
  display: 'flex',
  gap: 2,
  alignItems: 'center',
  justifyContent: 'center',
  right: '50%',
  transform: 'translateX(50%)',
  padding: theme.spacing(3, 6, 6),
  backgroundColor: theme.palette.background.paper,
  borderTopLeftRadius: theme.shape.borderRadius,
  borderTopRightRadius: theme.shape.borderRadius,
  animation: isHidden ? `${bounceOutAtFixedFooter} 0.6s ease-in-out` : 'none',
  bottom: isHidden ? '-100px' : '-16px',
  boxShadow: theme.shadows[1],
  '@media print': {
    display: 'none'
  }
}));

export const StyledButtonBoxWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isHovered'
})<{
  isHovered: boolean;
}>(({ isHovered, theme }) => ({
  position: 'absolute',
  zIndex: 1,
  right: theme.spacing(-2.5),
  top: theme.spacing(-2.5),
  backgroundColor: theme.palette.background.default,
  borderRadius: '50%',
  boxShadow: theme.shadows[2],
  opacity: isHovered ? 1 : 0, // Smooth fade-in/out
  transform: isHovered ? 'scale(1)' : 'scale(0.8)', // Small to big effect
  transition: 'opacity 0.3s ease-in-out, transform 0.3s ease-in-out'
}));
